<template>
    <div>
        <UserCategoriesList/>
    </div>
</template>
<script>
    import UserCategoriesList from '../users/UserCategoriesList';
    export default {
        name: 'user-flow',
        components: {UserCategoriesList},
    }
</script>